import { IApplicationState } from '../../types/redux';

export const selectIsCianAuthorizedModalOpen = (state: IApplicationState): boolean =>
  state.calculator.isCianAuthorizedModalOpen;
